import React from 'react'
import { Link } from 'react-router-dom'
import TableShell from '../../../components/ui/TableShell'

const money = (value) => new Intl.NumberFormat('ru-RU', { maximumFractionDigits: 2 }).format(Number(value) || 0) + ' ₽'

export default function IncomeReportCash({ config, onConfigChange, readOnly }) {
  if (!config.payment_summary) return null
  const visible = config.show_cash_receipts !== false
  const cashActs = (config.acts_snapshot || []).filter((act) => act.payment_type === 'cash' && act.distribution_eligible)
  return <section className="report-cash-section">
    {!readOnly && <label className="report-cash-toggle"><input type="checkbox" checked={visible}
      onChange={(event) => onConfigChange({ ...config, show_cash_receipts: event.target.checked })} />Показывать наличные поступления в отчёте и экспорте</label>}
    {visible && <>
      <h2 className="ds-section-heading">Поступления наличными (вне официального отчёта)</h2>
      <p>Поступило: <strong>{money(config.payment_summary.cash_income)}</strong> · Выплаты по наличным актам: <strong>{money(config.payment_summary.cash_payouts)}</strong></p>
      {cashActs.length > 0 && <TableShell className="report-acts-scroll"><table className="ds-data-table">
        <thead><tr><th>Акт</th><th>Объект / стадия</th><th>Поступления</th><th>Выплаты сотрудникам</th></tr></thead>
        <tbody>{cashActs.map((act) => <tr key={act.act_id}>
          <td><Link to={`/act/${encodeURIComponent(act.act_id)}`}>{act.act_number}</Link></td>
          <td>{act.object_name || '—'}<br /><span className="ds-detail-list__muted">{act.stage_id || '—'}</span></td>
          <td>{money(act.amount)}</td><td>{money(act.employee_payout)}</td>
        </tr>)}</tbody>
      </table></TableShell>}
    </>}
  </section>
}
